export default __webpack_public_path__ + "static/media/login_bg.c32d0b18.svg";